module.exports = __webpack_public_path__ + "img/santo-manto.c99a1b13.svg";